import { useLocation } from '@reach/router';
import queryString from 'query-string';
import { BaseSchema } from 'yup';

/**
 * Read query parameters, sanitized by a yup schema.
 *
 * @param schema
 *   A Yup schema, used to sanitize the input.
 */
export const useQueryParameters = <T extends {}>(schema: BaseSchema<T>): T =>
  schema.cast(queryString.parse(useLocation().search));
